export default class KlevuSearchProductCard {
  fetchProductCard (productHandle) {
    return fetch(`${window.Shopify.routes.root}products/${productHandle}?section_id=search-overlay-product-card`)
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch product price');
        return response.text();
      })
      .then(text => {
        const result = new DOMParser().parseFromString(text, 'text/html');
        const resultHTML = result.getElementById('shopify-section-search-overlay-product-card').innerHTML;

        return resultHTML;
      });
  }
}
